"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amounts = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
const framer_motion_1 = require("framer-motion");
// eslint-disable-next-line import/no-extraneous-dependencies
const react_i18next_1 = require("react-i18next");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const amount_1 = require("../../../components/amount");
const amounts_module_css_1 = __importDefault(require("./amounts.module.css"));
const svg_selector_1 = require("../../../assets/svg-selector");
const dedust_png_1 = __importDefault(require("../../../assets/img/dedust.png"));
const buttonTgStyles = {
    background: 'var(--tg-theme-button-color)',
    color: 'var(--tg-theme-button-text-color)'
};
const modalTgStyles = { backgroundColor: 'var(--tg-theme-bg-color)' };
const TextTgStyles = { color: 'var(--tg-theme-text-color)' };
const TextHintTgStyles = { color: 'var(--tg-theme-hint-color)' };
const Amounts = (props) => {
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    const [webBtnDisabled, setWebBtnDisabled] = (0, react_1.useState)(true);
    const tonData2 = props.dedustOptions?.find(element => element.token === 'TON');
    const [swapError, setSwapError] = (0, react_1.useState)('');
    const [swapped, setSwapped] = (0, react_1.useState)(false);
    function enableBtn() {
        TgObj.MainButton.enable();
        TgObj.MainButton.show();
        const tonData = props.tokensData?.find(element => element.token === 'TON');
        if ((props.tokenBalance1.length.toString() === '0'
            || !props.isValidAmount
            || (props.token1.token === 'TON' && props.token2.token !== 'TON'
                && Number(props.token1.amount) < 0.5 + Number(props.tokenBalance1))
            || (props.token1.token !== 'TON' && props.token2.token === 'TON' && Number(props.token2.amount) < 0.5)
            || props.token1.token === props.token2.token
            || (props.token1.token !== 'TON' && props.token2.token !== 'TON' && Number(tonData?.amount) < 0.5)
            || (props.token1.token === 'TON' && Number(props.tokenBalance1) < 0.5)
            || (Number(props.token1.priceUSD) * Number(props.tokenBalance1) < 0)
            || props.estimateLoading
            || (Number(props.tokenBalance1) > Number(props.token1.amount)))
            && props.position === 0) {
            TgObj.MainButton.text = t('swap-modal.enter-valid-amount');
            console.log('DISABLE');
            TgObj.MainButton.disable();
            TgObj.MainButton.color = '#424B56';
            setWebBtnDisabled(true);
            console.log('START ERROR HANDLING');
            if (props.token1.token === props.token2.token) {
                console.log('identical ERROR');
                setSwapError('identical');
            }
            if ((props.token1.token === 'TON'
                && props.token2.token !== 'TON'
                && Number(props.token1.amount) < 0.5 + Number(props.tokenBalance1))) {
                console.log('remaining ERROR');
                setSwapError('remaining');
            }
            if ((props.token1.token !== 'TON' && props.token2.token === 'TON' && Number(props.token2.amount) < 0.5)
                || (props.token1.token !== 'TON' && props.token2.token !== 'TON' && Number(tonData?.amount) < 0.5)) {
                console.log('jettonSwapRemaining ERROR');
                setSwapError('jettonSwapRemaining');
            }
            if ((props.token1.token === 'TON' && Number(props.tokenBalance1) < 0.5)) {
                console.log('minTon ERROR');
                setSwapError('minTon');
            }
            if (Number(props.token1.priceUSD) * Number(props.tokenBalance1) < 0.5) {
                console.log('minUsd ERROR');
                setSwapError('minUsd');
            }
            if (Number(props.tokenBalance1) > Number(props.token1.amount)) {
                setSwapError('Insufficient balance');
                console.log('props.tokenBalance1', props.tokenBalance1);
                console.log('props.token1.amount', props.token1.amount);
                setSwapError('insufficient');
            }
            if (!props.isValidAmount) {
                console.log('invalid amount');
            }
        }
        else if ((props.tokenBalance1.length.toString() !== '0' && props.isValidAmount) && props.position === 0) {
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('send.enter-amount-position.proceed');
            TgObj.MainButton.enable();
            setWebBtnDisabled(false);
        }
        // else {
        //     console.log('props.tokenBalance1.length.toString()', props.tokenBalance1.length.toString())
        //     TgObj.MainButton.color = '#424B56'
        //     TgObj.MainButton.text = t('swap-modal.enter-valid-amount')
        //     TgObj.MainButton.disable()
        //     setWebBtnDisabled(true)
        // }
    }
    (0, react_1.useEffect)(() => {
        if (props.position !== 0)
            return;
        enableBtn();
        console.log('props.tokenBalance1.length.toString()', props.tokenBalance1.length.toString());
        const handleBtnClick = () => {
            TgObj.HapticFeedback.impactOccurred('medium');
            props.setPosition(1);
        };
        if (props.isModalOpen) {
            TgObj.MainButton.hide();
        }
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [
        props.position === 0,
        props.isValidAmount,
        props.tokenBalance1.length.toString() === '0',
        props.position,
        props.isModalOpen,
        props.tokenBalance1,
        props.token2,
        props.token1,
        props.position,
        props.tokenBalance2,
        props.token1.token,
        props.token2.token,
        props.token1.amount,
        props.token1.priceUSD
    ]);
    function enableBackBtn() {
        TgObj.BackButton.show();
    }
    (0, react_1.useEffect)(() => {
        enableBackBtn();
        TgObj.BackButton.onClick(props.handleCloseModal);
        return () => {
            TgObj.BackButton.offClick(props.handleCloseModal);
        };
    }, []);
    //= ======== get Price impact
    const [priceImpact, setPriceImpact] = (0, react_1.useState)('0');
    const [isNegativeImpact, setIsNegativeImpact] = (0, react_1.useState)(true);
    const getPriceImpact = () => {
        const amountUsd1 = Number(props.tokenBalance1) * Number(props.token1.priceUSD);
        const amountUsd2 = Number(props.tokenBalance2) * Number(props.token2.priceUSD);
        const impact = ((amountUsd1 - amountUsd2) / amountUsd1) * 100;
        setPriceImpact(impact.toFixed(2));
    };
    (0, react_1.useEffect)(() => {
        getPriceImpact();
    }, [props.tokenBalance1, props.tokenBalance2]);
    console.log('PriceImpact');
    console.log((Number(props.tokenBalance1) * Number(props.token1.priceUSD)), 'amountUsd1');
    console.log((Number(props.tokenBalance2) * Number(props.token2.priceUSD)), 'amountUsd2');
    console.log('priceImpact', priceImpact);
    let errorText = '';
    switch (swapError) {
        case 'remaining':
            errorText = t('swap-modal.remaining');
            break;
        case 'jettonSwapRemaining':
            errorText = t('swap-modal.jetton-swap-remaining');
            break;
        case 'identical':
            errorText = t('swap-modal.identical');
            break;
        case 'minTon':
            errorText = t('swap-modal.min-ton');
            break;
        case 'minUsd':
            errorText = t('swap-modal.min-usd');
            break;
        case 'insufficient':
            errorText = t('swap-modal.insufficient');
            break;
        default:
            errorText = '';
            break;
    }
    const SwitchHandler = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        props.handleSwitch();
        setSwapped(!swapped);
    };
    const switchAnimationStyle = (0, react_1.useMemo)(() => {
        if (swapped) {
            return (amounts_module_css_1.default.switcherUp);
        }
        return (amounts_module_css_1.default.switcherDown);
    }, [swapped]);
    const variants = {
        open: { rotate: 180 },
        closed: { rotate: 0 }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.wrapper, children: [(0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.modalColumn, children: [(0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.modalContent, children: [(0, jsx_runtime_1.jsx)(amount_1.Amount, { options: props.tokensData, value: props.tokenBalance1, onChange: (e) => props.setTokenBalance1(e.target.value), setAmount: props.setTokenBalance1, selectedValue: props.token1, handleSelect: props.setToken1, isTg: props.isTg, setIsValidAmount: props.setIsValidAmount, currentAmount: props.tokenBalance1, isModalOpen: props.isModalOpen, setIsModalOpen: props.setIsModalOpen, setIsFromAssets: props.setIsFromAssets, isFromAssets: props.isFromAsset, setEstimateLoading: props.setEstimateLoading }), (0, jsx_runtime_1.jsx)("div", { className: `${amounts_module_css_1.default.modalContentSwap}`, onClick: SwitchHandler, children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { animate: swapped ? 'open' : 'closed', variants: variants, className: amounts_module_css_1.default.swapButtonWrapper, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "swap-5" }) }) }), (0, jsx_runtime_1.jsx)(amount_1.Amount, { options: props.tokensData, value: props.tokenBalance2, onChange: (e) => props.setTokenBalance2(e.target.value), setAmount: props.setTokenBalance2, selectedValue: props.token2, handleSelect: props.setToken2, isTg: props.isTg, onlyRead: true, currentAmount: props.tokenBalance2, isModalOpen: props.isModalOpen, setIsModalOpen: props.setIsModalOpen, setIsFromAssets: props.setIsFromAssets, isFromAssets: props.isFromAsset, estimateLoading: props.estimateLoading })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: amounts_module_css_1.default.infoWrapper, children: [(0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.infoRow, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: amounts_module_css_1.default.hintText, children: t('common.price-impact') }), !props.estimateLoading && (Number(priceImpact) > 0.00 && Number(priceImpact) <= 100 && !props.estimateLoading) && (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: amounts_module_css_1.default.ordinaryText, children: [priceImpact, "%"] }), props.estimateLoading && (0, jsx_runtime_1.jsx)(de_ui_1.Spinner, { className: amounts_module_css_1.default.smallSpinner, size: 'small' })] }), (0, jsx_runtime_1.jsx)("div", { className: amounts_module_css_1.default.dottedLine, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "dotted-line" }) }), (0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.infoRow, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: amounts_module_css_1.default.hintText, children: t('common.trading-fee') }), (Number(tonData2?.priceUSD) && props.deWalletTonFee && props.deWalletTonFee !== undefined && !props.estimateLoading && tonData2?.priceUSD !== 'undefined') ? (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: amounts_module_css_1.default.ordinaryText, children: `${(props.deWalletTonFee + 0.25).toFixed(3)} TON ~ ${(Number(tonData2?.priceUSD) * (props.deWalletTonFee + 0.25)).toFixed(3)}$` }) : (0, jsx_runtime_1.jsx)(de_ui_1.Spinner, { className: amounts_module_css_1.default.smallSpinner, size: 'small' })] })] }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { tgStyles: TextHintTgStyles, className: `${amounts_module_css_1.default.hintText} ${amounts_module_css_1.default.description}`, children: t('common.swap-info') })] }), (0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.bottomWrapper, children: [(0, jsx_runtime_1.jsxs)("div", { className: amounts_module_css_1.default.poweredWrapper, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: amounts_module_css_1.default.poweredText, children: t('swap-modal.powered') }), (0, jsx_runtime_1.jsxs)("a", { className: amounts_module_css_1.default.dedustLink, target: "_blank", href: "https://dedust.io/", children: [(0, jsx_runtime_1.jsx)("img", { src: dedust_png_1.default, width: "12", height: "12", alt: "DeDust" }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: amounts_module_css_1.default.poweredTextBold, children: "DeDust" })] })] }), webBtnDisabled
                        && (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: amounts_module_css_1.default.errorWrapper, children: [(0, jsx_runtime_1.jsx)("div", { className: amounts_module_css_1.default.alertWrapper, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "alert" }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: amounts_module_css_1.default.errorText, children: errorText })] })] })] }));
};
exports.Amounts = Amounts;
